import {
  VIEWTRANSACTIONDETAILS_SUCCESS,
  VIEWTRANSACTIONDETAILS_FAILED,
  RESET_VIEWTRANSACTIONDETAILS,
  LOADING_VIEWTRANSACTIONDETAILS,
  NETWORK_ERROR_VIEWTRANSACTIONDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetViewTransactionDetails = () => {
  return { type: RESET_VIEWTRANSACTIONDETAILS };
};

const getViewTransactionDetails =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_VIEWTRANSACTIONDETAILS });
    await partnerServices
      .post("viewTransactionDetails", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "Success":
            dispatch(viewTransactionDetailssuccess(res.data));
            break;
          default:
            dispatch(viewTransactionDetailsFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({ type: NETWORK_ERROR_VIEWTRANSACTIONDETAILS, payload: err });
      });
  };
function viewTransactionDetailssuccess(data) {
  return {
    type: VIEWTRANSACTIONDETAILS_SUCCESS,
    payload: data,
  };
}
function viewTransactionDetailsFailed(data) {
  return {
    type: VIEWTRANSACTIONDETAILS_FAILED,
    payload: data,
  };
}

export { resetViewTransactionDetails, getViewTransactionDetails };
